module.exports = __webpack_public_path__ + "static/media/news-19.577ebadd.jpg";